import { Button } from '@ds';
import { MdOutlineClear } from 'react-icons/md';
import { FilterDropdown } from '@ui';
import { PERFUSION_SETS_ORGAN_LIST } from '@/constants/form.constants';
import { UseFiltersType } from '@/hooks/useFilters';
import { PerfusionSetListFilters } from '@/api/apis/resources';
import { FILTERS_NAMES } from '../config';

type PerfusionSetsFiltersProps = UseFiltersType<PerfusionSetListFilters>;

export const PerfusionSetsFilters = ({
  filters,
  hasFilters,
  updateFilters,
  clearFilters,
}: PerfusionSetsFiltersProps) => {
  return (
    <div className="flex gap-7 items-center">
      <FilterDropdown
        title={FILTERS_NAMES.organType}
        items={PERFUSION_SETS_ORGAN_LIST}
        selectedKeys={filters.inventoryPartTypes}
        mode="multiple"
        onSelectedKeysChange={(values) => updateFilters(values, 'inventoryPartTypes')}
      />
      {hasFilters && (
        <Button startContent={<MdOutlineClear size={18} />} size="sm" variant="light" onClick={clearFilters}>
          Clear all
        </Button>
      )}
    </div>
  );
};
